import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=74854d2b&"
import script from "./MediaItem.vue?vue&type=script&lang=js&"
export * from "./MediaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports